// extracted by mini-css-extract-plugin
export var column = "_tr-0";
export var divider = "_tr-2";
export var timePicker = "_tr-1";